<script setup>
import { AlertDialogTrigger } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})
</script>

<template>
  <AlertDialogTrigger
    v-bind="props"
    :class="cn(props.class)"
  >
    <slot />
  </AlertDialogTrigger>
</template>
